module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Sort Items",
      "settings": _vm.settings
    },
    on: {
      "save": _vm.save,
      "show": _vm.initialise
    }
  }, [_c('div', {
    staticClass: "pa-2"
  }, [_c('v-btn-toggle', {
    attrs: {
      "dense": "",
      "multiple": ""
    },
    model: {
      value: (_vm.exportPreferences),
      callback: function($$v) {
        _vm.exportPreferences = $$v
      },
      expression: "exportPreferences"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    }
  }, [_vm._v("\n        Main\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    }
  }, [_vm._v("\n        Contacts\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    }
  }, [_vm._v("\n        Files\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    }
  }, [_vm._v("\n        Comments\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    }
  }, [_vm._v("\n        Emails\n        ")])], 1), _vm._v(" "), _c('v-btn-toggle', {
    staticClass: "ml-2",
    attrs: {
      "dense": "",
      "mandatory": ""
    },
    model: {
      value: (_vm.exportFormat),
      callback: function($$v) {
        _vm.exportFormat = $$v
      },
      expression: "exportFormat"
    }
  }, [_c('v-btn', [_vm._v("\n            HTML\n        ")]), _vm._v(" "), _c('v-btn', [_vm._v("\n            Text\n        ")])], 1)], 1), _vm._v(" "), (_vm.exportFormat == _vm.exportFormatOptions.HTML) ? _c('div', {
    ref: "export",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "max-width": "600px"
    }
  }, [(_vm.exportPreferences.includes(_vm.exportOptions.TRANSACTION)) ? [_c('div', {
    style: (_vm.headingStyle)
  }, [_vm._v(_vm._s(_vm.transactionDetails.clients))]), _vm._v(" "), _vm._l((_vm.importantElements), function(element) {
    return _c('div', {
      key: element.key,
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bolder",
        "padding": "10px",
        "flex-basis": "200px",
        "min-width": "200px",
        "background-color": "#ddd",
        "margin": "1px"
      }
    }, [_vm._v("\n                " + _vm._s(element.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px",
        "flex-grow": "1"
      },
      domProps: {
        "innerHTML": _vm._s(element.value)
      }
    })])
  })] : _vm._e(), _vm._v(" "), (_vm.exportPreferences.includes(_vm.exportOptions.CONTACTS)) ? [_c('div', {
    style: (_vm.headingStyle)
  }, [_vm._v("Contacts")]), _vm._v(" "), _vm._l((_vm.contacts), function(contact) {
    return _c('div', {
      key: contact['.key'],
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "title": JSON.stringify(contact)
      }
    }, [_c('img', {
      staticStyle: {
        "flex-basis": "40px",
        "margin": "5px",
        "border-radius": "50%"
      },
      attrs: {
        "src": contact.image,
        "width": "60px"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('div', {
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(_vm._f("fullName")(contact)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "color": "#555"
      }
    }, [_vm._v(_vm._s(_vm.phoneNumbers(contact)))])])])
  })] : _vm._e(), _vm._v(" "), (_vm.exportPreferences.includes(_vm.exportOptions.FILES)) ? [_c('div', {
    style: (_vm.headingStyle)
  }, [_vm._v("Files")]), _vm._v(" "), _vm._l((_vm.fileElements), function(element) {
    return _c('a', {
      key: element.key,
      attrs: {
        "href": element.value,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "hoverable",
      staticStyle: {
        "width": "100px",
        "padding": "10px",
        "display": "inline-block"
      },
      attrs: {
        "title": element.title
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imagePath,
        "width": "80px"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(element.title))])])])
  })] : _vm._e(), _vm._v(" "), (_vm.exportPreferences.includes(_vm.exportOptions.COMMENTS)) ? [_c('div', {
    style: (_vm.headingStyle)
  }, [_vm._v("Comment History")]), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('div', {
      key: comment['.key'],
      staticStyle: {
        "padding": "10px"
      }
    }, [_vm._v("\n            " + _vm._s(comment.text) + " "), _c('span', {
      staticStyle: {
        "color": "#888"
      }
    }, [_vm._v(" - " + _vm._s(_vm._f("fullName")(comment.stamp)) + " " + _vm._s(_vm._f("date")(comment.stamp.date)))])])
  })] : _vm._e(), _vm._v(" "), (_vm.exportPreferences.includes(_vm.exportOptions.EMAILS)) ? [_c('div', {
    style: (_vm.headingStyle)
  }, [_vm._v("Email History")]), _vm._v(" "), _vm._l((_vm.mailLog), function(mailLogItem) {
    return _c('div', {
      key: mailLogItem['id'],
      staticStyle: {
        "padding": "10px"
      }
    }, [_vm._v("\n            From: " + _vm._s(mailLogItem.email.from) + " "), _c('br'), _vm._v("\n            To: " + _vm._s(mailLogItem.email.to.map(function (recipient) { return recipient.email; }).join(', ')) + " "), _c('br'), _vm._v("\n            Subject: " + _vm._s(mailLogItem.email.subject)), _c('br'), _vm._v("\n            Body: " + _vm._s(_vm.removeHtml(mailLogItem.email.body))), _c('br'), _c('br')])
  })] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.exportFormat == _vm.exportFormatOptions.TEXT) ? _c('div', {
    staticClass: "full-width pa-3"
  }, [_c('textarea', {
    staticStyle: {
      "width": "100%",
      "border": "solid 1px #eee"
    },
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": _vm.allText
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-550eb268"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ExporterDialog.vue
// module id = 2552
// module chunks = 1